module.exports = __webpack_public_path__ + "media/packs/static/fonts/interUI/bold-43c0d8296b3c35a7afdda7725ad94137.woff";